module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "feature-area section-padding2",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": require("../../static/assets/images/012.jpg"),
      "mode": "aspectFill"
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2",
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', [_vm._v("Book a table")]), _vm._v(" "), _c('p', [_vm._v("📞 0466900048")]), _vm._v(" "), _c('h2', [_vm._v("Trading Hours")]), _vm._v(" "), _c('p', [_vm._v("Thursday 3:00pm – 9:00pm")]), _vm._v(" "), _c('p', [_vm._v("Friday 12:00pm – 10:00pm")]), _vm._v(" "), _c('p', [_vm._v("Saturday 12:00pm – 10:00pm")]), _vm._v(" "), _c('p', [_vm._v("Sunday 12:00pm – 8:00pm")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7162b4ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 240
// module chunks = 1